import forOwn from 'mout/object/forOwn'

export default function mergeAnswersByItem (prevAnswersByItem, newAnswersByItem) {
  let merged = Object.assign({}, prevAnswersByItem)
  forOwn(newAnswersByItem, (subtest, subtestId) => {
    if (merged[subtestId]) {
      forOwn(subtest, (answers, itemId) => {
        if (merged[subtestId][itemId]) {
          forOwn(answers, (count, answerId) => {
            if (merged[subtestId][itemId][answerId]) {
              merged[subtestId][itemId][answerId] += count
            } else {
              merged[subtestId][itemId][answerId] = count
            }
          })
        } else {
          merged[subtestId][itemId] = answers
        }
      })
    } else {
      merged[subtestId] = subtest
    }
  })
  return merged
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/mergeAnswersByItem.js